import { EntityModel } from '@/interfaces'
import {
  ALL_IMAGE_GALLERIES_QUERY,
  CREATE_IMAGE_GALLERY_MUTATION,
  DELETE_IMAGE_GALLERY_MUTATION,
  FORCE_DELETE_IMAGE_GALLERY_MUTATION,
  SINGLE_IMAGE_GALLERY_QUERY,
  UPDATE_IMAGE_GALLERY_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const imageGalleryModel: EntityModel = {
  name: 'imageGallery',
  namePlural: 'imageGalleries',
  uniqueName: 'imageGallery',
  uniqueNamePlural: 'imageGalleries',
  path: 'media/image_gallery',
  baseUrl: '/media/image_galleries',
  translationPrefix: 'entities:imageGallery.',
  getDisplayName: (values: any) => {
    return ''
  },
  gql: {
    getAll: ALL_IMAGE_GALLERIES_QUERY,
    getSingle: SINGLE_IMAGE_GALLERY_QUERY,
    create: CREATE_IMAGE_GALLERY_MUTATION,
    update: UPDATE_IMAGE_GALLERY_MUTATION,
    delete: DELETE_IMAGE_GALLERY_MUTATION,
    forceDelete: FORCE_DELETE_IMAGE_GALLERY_MUTATION,
  },
  attributes: {
    images: {
      name: 'images',
      label: 'entities:imageGallery.attributes.images.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default imageGalleryModel
